import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  FaUserFriends, 
  FaChild, 
  FaUtensils, 
  FaShower, 
  FaTshirt, 
  FaSuitcase,
  FaHeart,
  FaPalette,
  FaCalendarAlt,
  FaClock
} from 'react-icons/fa';
import './NosActions.css';

function NosActions() {
  const { t } = useTranslation();
  return (
    <div className="actions-page">
      {/* Hero Section */}
      <section className="actions-hero">
        <div className="container">
          <div className="actions-hero-content">
            <span className="eyebrow">{t('actions.eyebrow')}</span>
            <h1>{t('actions.title')}</h1>
            <p className="lead">
              {t('actions.lead')}
            </p>
          </div>
        </div>
      </section>

      {/* Main Services Section */}
      <section className="actions-services-section">
        <div className="container">
          <div className="section-header">
            <h2>{t('actions.mainServicesTitle')}</h2>
            <p>{t('actions.mainServicesSubtitle')}</p>
          </div>
          
          <div className="actions-services-grid">
            <div className="action-card">
              <div className="action-icon">
                <FaUserFriends />
              </div>
              <h3>{t('actions.socialServiceTitle')}</h3>
              <p>
                {t('actions.socialServiceDesc')}
              </p>
              <p className="action-note">
                {t('actions.socialServiceNote')}
              </p>
            </div>

            <div className="action-card">
              <div className="action-icon">
                <FaChild />
              </div>
              <h3>{t('actions.childrenServiceTitle')}</h3>
              <p>
                {t('actions.childrenServiceDesc')}
              </p>
              <div className="action-image">
                <img 
                  src="/uploads/2024/06/IMG-20231022-WA0019-300x225.jpg" 
                  alt="Espace enfants à RIVE"
                />
              </div>
            </div>

            <div className="action-card featured-card">
              <div className="featured-badge">{t('actions.convivialityBadge')}</div>
              <div className="action-icon" style={{ display: 'none' }}>
                <FaUtensils />
              </div>
              <h3>{t('actions.mealTitle')}</h3>
              <div className="meal-times">
                <div className="meal-time-item">
                  <FaClock className="time-icon" />
                  <div>
                    <strong>{t('actions.mealBreakfast')}</strong>
                    <span>{t('actions.mealBreakfastTime')}</span>
                  </div>
                </div>
                <div className="meal-time-item">
                  <FaClock className="time-icon" />
                  <div>
                    <strong>{t('actions.mealLunch')}</strong>
                    <span>{t('actions.mealLunchTime')}</span>
                  </div>
                </div>
              </div>
              <p dangerouslySetInnerHTML={{ __html: t('actions.mealDesc') }} />
              <div className="action-images">
                <img src="/uploads/2024/06/IMG-20231127-WA0009-225x300.jpg" alt="Préparation repas" />
                <img src="/uploads/2024/06/IMG-20231127-WA0010-225x300.jpg" alt="Repas partagé" />
                <img src="/uploads/2024/06/IMG-20230426-WA0050-225x300.jpg" alt="Cuisine RIVE" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Highlight: SIAO */}
      <section className="actions-highlight-siao">
        <div className="container">
          <div className="siao-box">
            <div className="siao-icon">
              <FaUserFriends />
            </div>
            <div className="siao-badge">{t('actions.siaoBadge')}</div>
            <h2 dangerouslySetInnerHTML={{ __html: t('actions.siaoTitle') }} />
            <div className="siao-explanation">
              <h3>{t('actions.siaoWhat')}</h3>
              <p dangerouslySetInnerHTML={{ __html: t('actions.siaoDesc') }} />
              <div className="siao-benefits">
                <div className="siao-benefit-item">
                  <div className="benefit-icon">✓</div>
                  <div>
                    <strong>{t('actions.siaoBenefit1Title')}</strong>
                    <p>{t('actions.siaoBenefit1Desc')}</p>
                  </div>
                </div>
                <div className="siao-benefit-item">
                  <div className="benefit-icon">✓</div>
                  <div>
                    <strong>{t('actions.siaoBenefit2Title')}</strong>
                    <p>{t('actions.siaoBenefit2Desc')}</p>
                  </div>
                </div>
                <div className="siao-benefit-item">
                  <div className="benefit-icon">✓</div>
                  <div>
                    <strong>{t('actions.siaoBenefit3Title')}</strong>
                    <p>{t('actions.siaoBenefit3Desc')}</p>
                  </div>
                </div>
              </div>
              <p className="siao-contact" dangerouslySetInnerHTML={{ __html: t('actions.siaoContact') }} />
            </div>
          </div>
        </div>
      </section>

      {/* Highlight: Free Services */}
      <section className="actions-highlight-free">
        <div className="container">
          <div className="highlight-box">
            <div className="highlight-icon">
              <FaHeart />
            </div>
            <h2 dangerouslySetInnerHTML={{ __html: t('actions.freeTitle') }} />
            <p className="highlight-subtitle">
              {t('actions.freeSubtitle')}
            </p>
          </div>
        </div>
      </section>

      {/* Free Services Section */}
      <section className="actions-free-services">
        <div className="container">
          <div className="section-header">
            <h2>{t('actions.essentialServicesTitle')}</h2>
            <p>{t('actions.essentialServicesSubtitle')}</p>
          </div>

          <div className="free-services-grid">
            <div className="free-service-card">
              <div className="free-service-icon">
                <FaShower />
              </div>
              <div className="free-service-content">
                <h3>{t('actions.showerTitle')}</h3>
                <p className="service-time">
                  <FaClock /> {t('actions.showerTime')}
                </p>
                <p>
                  {t('actions.showerDesc')}
                </p>
                <img 
                  src="/uploads/2016/05/salledebain-300x225.jpg" 
                  alt="Salle de bain RIVE"
                  className="service-image"
                />
              </div>
            </div>

            <div className="free-service-card">
              <div className="free-service-icon">
                <FaTshirt />
              </div>
              <div className="free-service-content">
                <h3>{t('actions.laundryTitle')}</h3>
                <p>
                  {t('actions.laundryDesc')}
                </p>
              </div>
            </div>

            <div className="free-service-card">
              <div className="free-service-icon">
                <FaSuitcase />
              </div>
              <div className="free-service-content">
                <h3>{t('actions.baggageTitle')}</h3>
                <p>
                  {t('actions.baggageDesc')}
                </p>
                <p className="service-note">
                  {t('actions.baggageNote')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Support Section */}
      <section className="actions-support-section">
        <div className="container">
          <div className="support-content">
            <div className="support-text">
              <div className="support-icon">
                <FaHeart />
              </div>
              <h2>{t('actions.psychologicalTitle')}</h2>
              <p>
                {t('actions.psychologicalDesc')}
              </p>
            </div>
            <div className="support-image">
              <img 
                src="/uploads/2017/11/20171010_154044-300x169.jpg" 
                alt="Soutien psychologique RIVE"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Activities Section */}
      <section className="actions-activities-section">
        <div className="container">
          <div className="section-header">
            <h2>{t('actions.activitiesTitle')}</h2>
            <p>{t('actions.activitiesSubtitle')}</p>
          </div>

          <div className="activities-grid">
            <div className="activity-item">
              <FaPalette className="activity-icon" />
              <span>{t('actions.activity1')}</span>
            </div>
            <div className="activity-item">
              <FaPalette className="activity-icon" />
              <span>{t('actions.activity2')}</span>
            </div>
            <div className="activity-item">
              <FaPalette className="activity-icon" />
              <span>{t('actions.activity3')}</span>
            </div>
            <div className="activity-item">
              <FaPalette className="activity-icon" />
              <span>{t('actions.activity4')}</span>
            </div>
            <div className="activity-item">
              <FaPalette className="activity-icon" />
              <span>{t('actions.activity5')}</span>
            </div>
            <div className="activity-item">
              <FaPalette className="activity-icon" />
              <span>{t('actions.activity6')}</span>
            </div>
            <div className="activity-item">
              <FaPalette className="activity-icon" />
              <span>{t('actions.activity7')}</span>
            </div>
            <div className="activity-item">
              <FaPalette className="activity-icon" />
              <span>{t('actions.activity8')}</span>
            </div>
          </div>

          <div className="activities-images">
            <img src="/uploads/2017/11/20171025_113343-300x169.jpg" alt="Activités RIVE" />
            <img src="/uploads/2024/06/IMG-20231022-WA0039-300x225.jpg" alt="Ateliers RIVE" />
          </div>

          <div className="activities-events">
            <div className="events-icon">
              <FaCalendarAlt />
            </div>
            <h3>{t('actions.eventsTitle')}</h3>
            <p>
              {t('actions.eventsDesc')}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default NosActions;
